var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCopy(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.4 24H10.8C8.81 24 7.2 22.39 7.2 20.4V16.8H3.6C1.61 16.8 0 15.19 0 13.2V3.6C0 1.61 1.61 0 3.6 0H13.2C15.19 0 16.8 1.61 16.8 3.6V7.2H20.4C22.39 7.2 24 8.81 24 10.8V20.4C24 22.39 22.39 24 20.4 24ZM9.6 15.6V20.4C9.6 21.06 10.14 21.6 10.8 21.6H20.4C21.06 21.6 21.6 21.06 21.6 20.4V10.8C21.6 10.14 21.06 9.6 20.4 9.6H10.8C10.14 9.6 9.6 10.14 9.6 10.8V15.6ZM3.6 2.4C2.94 2.4 2.4 2.94 2.4 3.6V13.2C2.4 13.86 2.94 14.4 3.6 14.4H7.2V10.8C7.2 8.81 8.81 7.2 10.8 7.2H14.4V3.6C14.4 2.94 13.86 2.4 13.2 2.4H3.6Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCopy);
export default __webpack_public_path__ + "static/media/copy.db290445cc1894ce17ea540f9d38c615.svg";
export { ForwardRef as ReactComponent };